export default __webpack_public_path__ + "static/media/brand-logo.7d5b2a3c.svg";